(() => {
  if (window.galixCookieBannerReady) return;
  window.galixCookieBannerReady = true;

  const root = document.querySelector('[data-galix-cookie-banner]');
  if (!root) return;

  const options = root.querySelector('#GalixCookieOptions');
  const configure = root.querySelector('[data-galix-cookie-configure]');
  const close = root.querySelector('[data-galix-cookie-close]');
  const error = root.querySelector('[data-galix-cookie-error]');
  const fields = {
    preferences: root.querySelector('[data-galix-cookie-preferences]'),
    analytics: root.querySelector('[data-galix-cookie-analytics]'),
    marketing: root.querySelector('[data-galix-cookie-marketing]')
  };
  const actionButtons = root.querySelectorAll('[data-galix-cookie-accept], [data-galix-cookie-reject], [data-galix-cookie-save]');
  let privacy = null;
  let decided = false;
  let saving = false;
  let lastOpener = null;

  const showError = () => { error.hidden = false; };
  const hideError = () => { error.hidden = true; };
  const setBusy = (busy) => {
    saving = busy;
    actionButtons.forEach(button => { button.disabled = busy; });
  };
  const show = (settings = false) => {
    root.hidden = false;
    close.hidden = !decided;
    options.hidden = !settings;
    configure.setAttribute('aria-expanded', String(settings));
    hideError();
    if (settings) fields.preferences.focus();
  };
  const hide = () => {
    root.hidden = true;
    options.hidden = true;
    configure.setAttribute('aria-expanded', 'false');
    lastOpener?.focus();
    lastOpener = null;
  };
  const syncFields = () => {
    if (!privacy) return;
    const consent = privacy.currentVisitorConsent();
    Object.keys(fields).forEach(key => { fields[key].checked = consent[key] === 'yes'; });
    decided = Object.keys(fields).every(key => consent[key] === 'yes' || consent[key] === 'no');
  };
  const save = (choice) => {
    if (saving) return;
    if (!privacy) { showError(); return; }
    hideError();
    setBusy(true);
    let finished = false;
    const timeout = setTimeout(() => {
      if (finished) return;
      finished = true;
      setBusy(false);
      showError();
    }, 8000);
    try {
      privacy.setTrackingConsent(choice, (result) => {
        if (finished) return;
        finished = true;
        clearTimeout(timeout);
        setBusy(false);
        if (result?.error) { showError(); return; }
        syncFields();
        decided = true;
        hide();
        document.dispatchEvent(new CustomEvent('galix:cookie-consent', { detail: choice }));
      });
    } catch (_) {
      finished = true;
      clearTimeout(timeout);
      setBusy(false);
      showError();
    }
  };

  root.querySelector('[data-galix-cookie-accept]').addEventListener('click', () => save({ preferences: true, analytics: true, marketing: true }));
  root.querySelector('[data-galix-cookie-reject]').addEventListener('click', () => save({ preferences: false, analytics: false, marketing: false }));
  root.querySelector('[data-galix-cookie-save]').addEventListener('click', () => save({ preferences: fields.preferences.checked, analytics: fields.analytics.checked, marketing: fields.marketing.checked }));
  configure.addEventListener('click', () => {
    const opening = options.hidden;
    options.hidden = !opening;
    configure.setAttribute('aria-expanded', String(opening));
    if (opening) fields.preferences.focus();
  });
  close.addEventListener('click', hide);
  document.addEventListener('click', (event) => {
    const opener = event.target instanceof Element ? event.target.closest('[data-galix-cookie-open]') : null;
    if (!opener) return;
    lastOpener = opener;
    syncFields();
    show(true);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden && decided) hide();
  });

  // Banner y consentimiento previo solo en Europa (UE/EEE, Reino Unido, Suiza y resto del continente).
  const EUROPE = new Set(['AD', 'AL', 'AT', 'AX', 'BA', 'BE', 'BG', 'BY', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FO', 'FR', 'GB', 'GG', 'GI', 'GR', 'HR', 'HU', 'IE', 'IM', 'IS', 'IT', 'JE', 'LI', 'LT', 'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'RS', 'SE', 'SI', 'SJ', 'SK', 'SM', 'UA', 'VA', 'XK']);
  const visitorCountry = () => {
    let region = '';
    try { region = privacy.getRegion?.() || ''; } catch (_) {}
    const country = (region || window.Shopify?.country || '').slice(0, 2).toUpperCase();
    return /^[A-Z]{2}$/.test(country) ? country : '';
  };
  const inEurope = () => {
    const country = visitorCountry();
    return country ? EUROPE.has(country) : true;
  };

  if (!window.Shopify?.loadFeatures) return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (loadError) => {
    if (loadError || !window.Shopify.customerPrivacy) { show(); showError(); return; }
    privacy = window.Shopify.customerPrivacy;
    syncFields();
    if (decided) return;
    if (inEurope()) { show(); return; }
    // Fuera de Europa: sin banner y cookies activas por defecto (el enlace del footer sigue permitiendo cambiarlo).
    try {
      privacy.setTrackingConsent({ preferences: true, analytics: true, marketing: true }, () => {
        syncFields();
        document.dispatchEvent(new CustomEvent('galix:cookie-consent', { detail: 'auto-outside-europe' }));
      });
    } catch (_) {}
  });
})();
